import React from 'react'
import { Input, Cards, BreadcrumbGroup, Spinner } from 'AWS-UI-Components-React'
import { CARDS_PER_ROW, BREADCRUMB_ITEMS } from './SellerLookupConstants'
import './SellerLookupView.css'

export default class SellerLookupView extends React.Component {

    shouldComponentUpdate(nextProps) {
        return (this.props.loading !== nextProps.loading)
    }

    render() {
        const { handleKeydown, handleInput, disableSearch, invalidInput } = this.props;
        return (
            <div>
                <BreadcrumbGroup label="Breadcrumbs" items={BREADCRUMB_ITEMS}></BreadcrumbGroup>
                <Input 
                    className="awsui-util-mb-m"
                    placeholder="Enter seller AWS Account ID" 
                    type="search"
                    onKeydown={handleKeydown}
                    onInput={handleInput}
                    disabled={disableSearch}
                    invalid={invalidInput}>
                </Input>
                {this.renderCards()}
            </div>
        )
    }

    renderCards() {
        const { seller, loading, renderCardDefinition } = this.props
        if (loading) {
            return <div className="awsui-util-t-c"><Spinner size="large"></Spinner></div>
        }
        if (seller !== null) {
            return Object.keys(seller).map((key,index) => {
                if (seller[key] !== null) {
                    return <Cards
                        key={key}
                        id={key}
                        cardDefinition={renderCardDefinition(seller[key], key)}
                        items={[seller]}
                        cardsPerRow={CARDS_PER_ROW}
                        >
                    </Cards>
                    }
                }
            )
        }
    }

}


// WEBPACK FOOTER //
// ./src/components/Seller/Lookup/SellerLookupView.jsx